import React from 'react';
import styled from 'styled-components/macro';


const InfoBoxTable = ({ data, showTotal = false }) => {
    const rows = Array.isArray(data) ? data : [];
    return (
        <Table>
            <tbody>
                {rows.map((row, index) => {
                    const isLastRow = index === rows.length - 1;
                    const shouldShowTotal = showTotal && isLastRow;
                    
                    const RowComponent = shouldShowTotal ? TableRowTotal : TableRow;
                    
                    return (
                        <RowComponent key={index}>
                            <TableCell>{row.name}</TableCell>
                            <TableCell dangerouslySetInnerHTML={{ __html: row.value }} />
                        </RowComponent>
                    );
                })}
            </tbody>
        </Table>
    );
};


export default InfoBoxTable;


const Table = styled.table`
    margin: 0;
    padding: 0;
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
`;

const TableRow = styled.tr`
    margin: 0;
    padding: 0;
`;

const TableCell = styled.td`
    margin: 0;
    padding: .5rem 0;
    border-bottom: 0.1rem solid ${props => props.theme.secondary_color};

    &:last-child {
        text-align: right;
    }
`;

const TableRowTotal = styled(TableRow)`
    font-weight: 700;
`;
